const maskedCpf = function(cpf){
    if(!cpf){
        return null;
    }

    let maskedCpf = cpf;
    //remove mascara, se houver:
    maskedCpf = maskedCpf.replace(new RegExp("\\.","g"),"").replace(/-/g, "");
    //completa com zeros esquerda:
    maskedCpf = ("00000000000"+maskedCpf).slice(-11);

    return maskedCpf.substring(0,3) + "." + maskedCpf.substring(3,6) + "." + maskedCpf.substring(6,9) + "-" + maskedCpf.substring(9);
   
};

const maskedCnpj = function(cnpj){
    if(! cnpj){
        return null;
    }
    
    let maskedCnpj = cnpj;
    //remove mascara, se houver:
    maskedCnpj = maskedCnpj.replace(/[.\-/]/g, "");
    //completa com zeros esquerda:
    maskedCnpj = maskedCnpj.toUpperCase().padStart(14, '0').slice(-14);

    return maskedCnpj.substring(0,2) + "." + maskedCnpj.substring(2,5) + "." + maskedCnpj.substring(5,8) + "/" + maskedCnpj.substring(8,12) + "-" + maskedCnpj.substring(12);
   
};

const maskedCnpjInput = function(cnpj){
    if(!cnpj) return "";
    
    let value = cnpj.replace(/[.\-/]/g, "").toUpperCase().slice(0, 14);
    
    if (value.length <= 2) return value;
    if (value.length <= 5) return value.substring(0,2) + "." + value.substring(2);
    if (value.length <= 8) return value.substring(0,2) + "." + value.substring(2,5) + "." + value.substring(5);
    if (value.length <= 12) return value.substring(0,2) + "." + value.substring(2,5) + "." + value.substring(5,8) + "/" + value.substring(8);
    return value.substring(0,2) + "." + value.substring(2,5) + "." + value.substring(5,8) + "/" + value.substring(8,12) + "-" + value.substring(12);
};

export {maskedCpf, maskedCnpj, maskedCnpjInput}